import { createApp } from 'vue';

import rfpIframeMainContainer from './Components/iframe/Widget/rfp-iframe-main-container.vue';
import rfpIframeLoader from './Components/iframe/Widget/rfp-iframe-loader.vue';
import rfpIframeError from './Components/iframe/Widget/rfp-iframe-error.vue';

const app = createApp({});

[rfpIframeMainContainer, rfpIframeLoader, rfpIframeError].forEach((c) => app.component(c.name, c));
